<template>
  <div class="container">
    <div class="card shadow pt-2 ps-3 pe-3">
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="form-group">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item">
                  <a href="/inicio">Início</a>
                </li>
                <li class="breadcrumb-item">
                  <a href="/colunistas">Colunistas</a>
                </li>
                <li class="breadcrumb-item">
                  <a style="color: grey; hover: none">Cadastrar Colunista</a>
                </li>
              </ol>
              <h3 style="color: #000; margin-left: 15px">
                Cadastrar Colunista
              </h3>
            </nav>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-6">
          <label>Nome</label>
          <input
            type="text"
            class="form-control"
            v-model="state.nome"
            placeholder="Insira o nome do(a) colunista"
          />
        </div>
        <div class="col-6">
          <label>Nome URL</label>
          <input
            type="text"
            class="form-control"
            v-model="state.nome_url"
            placeholder="Insira um nome url"
          />
        </div>

        <div class="col-6">
          <div class="form-group">
            <label>Status</label>
            <select class="form-select" v-model="state.status">
              <option value="ATIVO">Ativo</option>
              <option value="INATIVO">Inativo</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-4">
          <label>Imagem</label>
          <input type="file" class="form-control" @change="adicionarImagem" />
        </div>
        <div style="display: flex" class="col" v-if="state.imagem.imagem">
          <img :src="state.imagem.imagem" class="imagem" />
          <button class="btn_deletar_imagem" @click="removerImagem">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="10"
              fill="currentColor"
              class="bi bi-x-lg mb-2"
              viewBox="0 0 16 16"
            >
              <path
                d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"
              />
            </svg>
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col">
          <div class="form-group">
            <label>Descrição</label>
            <textarea
              class="form-control"
              v-model="state.descricao"
              rows="3"
              maxlength="255"
              placeholder="Máximo de 255 caracteres"
            >
            </textarea>
            <div class="contator-area">
              <span class="caracter">{{ state.descricao.length }} / 255</span>
            </div>
          </div>
        </div>
      </div>

      <div class="row justify-content-end">
        <div class="col-auto">
          <button
            class="btn btn_voltar btn-secondary me-3"
            id="voltar-button"
            type="submit"
            @click="router.push({ name: 'colunistas' })"
          >
            Voltar
          </button>

          <button
            class="btn btn_salvar float-end"
            id="submit-button"
            type="submit"
            @click="salvarColunista"
          >
            Cadastrar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import { useRouter } from "vue-router";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const router = useRouter();
    const storage = useStorage();
    var token = storage.getStorageSync("token");

    const state = reactive({
      id: "",
      nome: "",
      nome_url: "",
      imagem: {},
      descricao: "",
      status: "ATIVO",
    });

    onMounted(() => {
      if (router.currentRoute._value.params.id != undefined) {
        fetchColunista();
      }
    });

    async function fetchColunista() {
      try {
        const { data } = await services.colunista.getById({
          id: router.currentRoute._value.params.id,
          token,
        });
        state.id = data.id;
        state.nome = data.nome;
        state.nome_url = data.nome_url;
        state.descricao = data.descricao;
        if (state.descricao == null || state.descricao == undefined) {
          state.descricao = "";
        }
        state.status = data.status;
        if (data.imagem != null) {
          state.imagem.imagem = data.imagem;
        }
      } catch (error) {
        console.log(error);
      }
    }
    async function salvarColunista() {
      let dados = new FormData();
      dados.append("nome", state.nome);
      dados.append("nome_url", state.nome_url);
      // dados.append("descricao", descricao);
      dados.append("status", state.status);
      if (state.descricao == null) {
        dados.append("descricao", state.descricao);
      } else {
        dados.append("descricao", state.descricao);
      }
      if (state.imagem.file != null) {
        dados.append("imagem", state.imagem.file);
      }

      if (!state.id) {
        try {
          await services.colunista.save(dados, token);
          router.push({ name: "colunistas" });
        } catch (error) {
          console.log(error);
        }
      } else {
        dados.append("id", state.id);
        dados.append("_method", "PUT");
        if (state.imagem.imagem == undefined) {
          try {
            await services.colunista.deletarImagem({
              id: dados.get("id"),
            });
          } catch (error) {
            console.log(error);
          }
        }

        try {
          await services.colunista.update(dados, token);
          router.push({ name: "colunistas" });
        } catch (error) {
          console.log(error);
        }
      }
    }
    async function adicionarImagem(event) {
      var img = event.target.files[0];

      var objImagem = new Object();
      objImagem.file = img;
      objImagem.imagem = URL.createObjectURL(img);
      state.imagem = objImagem;
    }
    async function removerImagem() {
      state.imagem = {};
      document.querySelector('input[type="file"]').value = null;
    }
    return {
      salvarColunista,
      adicionarImagem,
      removerImagem,
      router,
      state,
    };
  },
};
</script> 

<style scoped>
label {
  font-size: 14pt;
  color: #000;
  margin-bottom: 0;
}
input {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
input:focus {
  border: solid 1px blue;
}
select {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
}
select:focus {
  border: solid 1px blue;
}
textarea {
  border: solid 1px #000;
  margin-bottom: 10px;
  font-size: 12pt;
  color: #000;
  resize: none;
}
textarea:focus {
  border: solid 1px blue;
}
.card {
  min-height: 94.8vh;
}

.btn_salvar {
  background: green;
  color: #fff;
  transform: none;
}
#descricao {
  resize: none;
}
.btn_salvar:hover {
  color: #fff;
}
.btn_deletar_imagem {
  width: 25px;
  height: 25px;
  margin-left: 3px;
  background: rgb(170, 0, 0);
  color: #fff;
  border: solid 1px rgb(170, 0, 0);
  border-radius: 5px;
  transition: 0.3s;
}
.btn_deletar_imagem:hover {
  background: rgb(228, 0, 0);
  color: #fff;
  border: solid 1px rgb(228, 0, 0);
}
.imagem {
  height: 150px;
  width: 150px;
  border-radius: 100%;
  border: 3px solid green;
  object-fit: cover;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
.contator-area {
  text-align: right;
}
.caracter {
  color: #000;
}
</style>